var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCwwIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 283.46,
    height: 283.46,
    rx: 141.73,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.492 173.214C209.749 171.213 205.895 171.8 203.88 174.524C189.318 194.216 166.944 205.515 142.49 205.515C100.484 205.515 66.3067 171.578 66.3067 129.867C66.3067 88.157 100.484 54.2281 142.49 54.2281C166.944 54.2281 189.318 65.5271 203.88 85.2191C205.887 87.9426 209.749 88.5302 212.484 86.5292C215.227 84.5283 215.819 80.7011 213.803 77.9855C197.147 55.4509 170.486 42 142.49 42C93.695 42 54 81.4157 54 129.867C54 178.319 93.695 217.735 142.49 217.735C146.68 217.735 150.838 217.401 154.941 216.806L161.242 235.124H110.288C108.657 235.124 107.329 236.442 107.329 238.062C107.329 239.682 108.657 241 110.288 241H181.465C183.097 241 184.424 239.682 184.424 238.062C184.424 236.442 183.097 235.124 181.465 235.124H167.487L160.826 215.758C181.817 211.279 200.841 199.282 213.803 181.757C215.819 179.042 215.227 175.215 212.492 173.214Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwwIcon);
export default __webpack_public_path__ + "static/media/CWWIcon.e87d96373c6f56b7a91d55f4c68e3486.svg";
export { ForwardRef as ReactComponent };